const trainingPlansHeader = {
  "training-plans.header.start": "Crear plan",
  "training-plans.header.progress": "{{ completed }}/{{ required }}",
  "training-plans.header.complete": "SEMANA COMPLETA",
  "training-plans.header.loading": "CARGANDO PLAN",
  "training-plans.header.unavailable": "PLAN DE ENTRENAMIENTO",
  "training-plans.header.label": "Plan de entrenamiento: {{ status }}",
  "training-plans.header.label-with-streak": "Plan de entrenamiento: {{ status }}, racha de {{ count }} semanas",
};

const trainingPlansDrawer = {
  "training-plans.drawer.title": "Tu plan de entrenamiento",
  "training-plans.drawer.action.edit": "Editar plan de entrenamiento",
  "training-plans.drawer.action.close": "Cerrar plan de entrenamiento",
  "training-plans.drawer.loading.title": "Cargando tu plan de entrenamiento",
  "training-plans.drawer.loading.description": "Estamos cargando tu plan de entrenamiento personalizado.",
  "training-plans.drawer.building.title": "Creando tu plan de entrenamiento",
  "training-plans.drawer.building.description": "Estamos analizando tu nivel para crear tu plan semanal personalizado.",
  "training-plans.drawer.streak": "Racha de {{ count }} semanas",
  "training-plans.drawer.progress.title": "Progreso semanal",
  "training-plans.drawer.progress.complete-message": "Buen trabajo. Tu plan semanal está completo. Aparecerá un nuevo plan la próxima semana.",
  "training-plans.drawer.entries.title": "Esta semana",
  "training-plans.drawer.entry.day": "Día {{ day }}",
  "training-plans.drawer.entry.completed-on": "Completado el {{ date }}",
  "training-plans.drawer.entry.recommended-session": "Sesión de entrenamiento recomendada",
  "training-plans.drawer.entry.match-play": "Modo Partido",
  "training-plans.drawer.entry.career": "Carrera",
  "training-plans.drawer.entry.challenges": "Desafíos",
  "training-plans.drawer.entry.practice": "Práctica",
  "training-plans.drawer.entry.practice.count": "{{ count }} escenarios",
};

const trainingPlansOnboarding = {
  "training-plans.onboarding.loading.title": "Cargando opciones del plan de entrenamiento",
  "training-plans.onboarding.loading.description": "Estamos preparando tus opciones de plan de entrenamiento personalizadas.",
  "training-plans.onboarding.intro.title": "Presentamos los planes de entrenamiento",
  "training-plans.onboarding.intro.description": "Obtén un plan de entrenamiento personalizado para mantener la constancia y seguir tu progreso.",
  "training-plans.onboarding.intro.start": "Comenzar",
  "training-plans.onboarding.intro.not-interested": "No me interesa",
  "training-plans.onboarding.profile.title": "Punto de partida",
  "training-plans.onboarding.profile.description": "Elige la opción que mejor representa tu nivel actual de escaneo.",
  "training-plans.onboarding.profile.continue": "Continuar",
  "training-plans.onboarding.frequency.title": "Frecuencia",
  "training-plans.onboarding.frequency.description": "Elige cuantas veces quieres entrenar cada semana.",
  "training-plans.onboarding.frequency.option": "{{ count }} {{ unit }} por semana",
  "training-plans.onboarding.frequency.unit.singular": "vez",
  "training-plans.onboarding.frequency.unit.plural": "veces",
  "training-plans.onboarding.frequency.suggested": "Sugerido",
  "training-plans.onboarding.frequency.loading": "Guardando plan",
  "training-plans.onboarding.frequency.submit.update": "Actualizar plan de entrenamiento",
  "training-plans.onboarding.frequency.submit.create": "Crear plan de entrenamiento",
  "training-plans.onboarding.error.unavailable.title": "Plan de entrenamiento no disponible",
  "training-plans.onboarding.error.unavailable.message": "No pudimos encontrar un plan de entrenamiento disponible para tu seleccion.",
  "training-plans.onboarding.error.update.title": "No se pudo actualizar el plan de entrenamiento",
  "training-plans.onboarding.error.update.message": "Vuelve a intentarlo en un momento.",
};

const trainingPlansToast = {
  "training-plans.toast.progress.title": "Progreso del plan de entrenamiento",
  "training-plans.toast.progress.message": "Buen trabajo. Has completado {{ completed }} de {{ required }} sesiones esta semana.",
  "training-plans.toast.complete.title": "Plan de entrenamiento completado",
  "training-plans.toast.complete.message": "Excelente. Tu plan de entrenamiento semanal esta completo.",
};

export const trainingPlans = {
  ...trainingPlansHeader,
  ...trainingPlansDrawer,
  ...trainingPlansOnboarding,
  ...trainingPlansToast,
};
